import axios from 'axios'
import { Message } from './message'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { getRequestToken } from '@/utils/request-token'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // 跨域请求时发送 cookies
  timeout: 5000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = getRequestToken(store.getters.token || getToken())
    if (token) {
      // 让每个请求携带 token
      config.headers['X-Token'] = token
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 如果自定义 code 不是 20000，则判定为错误
    if (res.code !== 20000) {
      Message.error(res.message || 'Error', 5000)

      // 50008: 非法 token; 50012: 其他客户端已登录; 50014: Token 过期
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // 重新登录
        if (confirm('您已登出，请重新登录')) {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        }
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message.error(error.message, 5000)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js